import api from "./api";

export const getVehicleFiSummary = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      vehicle_uuid: params.vehicle_uuid,
    };

    const response = await api.post("/v1/tenant/finance_insurance/vehicle/summary", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle FI summary:", error);
    throw error;
  }
};

